// extracted by mini-css-extract-plugin
export default {"root":"RightBarContent_root__W8j2w","complexHistoryLink":"RightBarContent_complexHistoryLink__bXrVR","placeHolderShimmer":"RightBarContent_placeHolderShimmer__uZhjd"};